export const userlinks = [
  { id: 1, text: 'home', path: '/' },
  { id: 2, text: 'lessen', path: 'lessen' },
  { id: 3, text: 'Activiteiten', path: 'activiteiten' },
  { id: 4, text: 'contact', path: 'contact' },
  //{ id: 5, text: 'about', path: 'about' },
];
